import { useMutation } from "@apollo/client";

import { GqlMapEditorLayerUpdateInput, gql } from "~/__generated__";

import { ProjectMapEditorScreen_GetProjectDocument } from "../../project/screens/ProjectMapEditorScreen/queries.generated";
import { MapEditorGetAllLayerFeaturesDocument } from "./useMapEditorGetAllLayerFeatures.generated";
import { MAP_EDITOR_LAYER_GET_BY_ID } from "./useMapEditorLayerGetById";

const MAP_EDITOR_LAYER_UPDATE = gql(`
    mutation MapEditorLayerUpdate($input: GqlMapEditorLayerUpdateInput!) {
        mapEditorLayerUpdate(input: $input) {
            id
            name
            config
            color
            style
        }
    }
`);

export default function useMapLayerUpdate() {
    const [layerUpdate, { data, loading, error }] = useMutation(MAP_EDITOR_LAYER_UPDATE, {
        refetchQueries: [
            MapEditorGetAllLayerFeaturesDocument,
            MAP_EDITOR_LAYER_GET_BY_ID,
            ProjectMapEditorScreen_GetProjectDocument,
        ],
    });

    return {
        layerUpdate: (input: GqlMapEditorLayerUpdateInput) =>
            layerUpdate({
                variables: { input },
            }),
        loading,
        error,
        data: data?.mapEditorLayerUpdate,
    };
}
